// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class FirmwareVersionMessage implements flatbuffers.IUnpackableObject<FirmwareVersionMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FirmwareVersionMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFirmwareVersionMessage(bb:flatbuffers.ByteBuffer, obj?:FirmwareVersionMessage):FirmwareVersionMessage {
  return (obj || new FirmwareVersionMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFirmwareVersionMessage(bb:flatbuffers.ByteBuffer, obj?:FirmwareVersionMessage):FirmwareVersionMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FirmwareVersionMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

major():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
}

minor():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
}

revision():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
}

static startFirmwareVersionMessage(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addMajor(builder:flatbuffers.Builder, major:number) {
  builder.addFieldInt8(0, major, 0);
}

static addMinor(builder:flatbuffers.Builder, minor:number) {
  builder.addFieldInt8(1, minor, 0);
}

static addRevision(builder:flatbuffers.Builder, revision:number) {
  builder.addFieldInt8(2, revision, 0);
}

static endFirmwareVersionMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createFirmwareVersionMessage(builder:flatbuffers.Builder, major:number, minor:number, revision:number):flatbuffers.Offset {
  FirmwareVersionMessage.startFirmwareVersionMessage(builder);
  FirmwareVersionMessage.addMajor(builder, major);
  FirmwareVersionMessage.addMinor(builder, minor);
  FirmwareVersionMessage.addRevision(builder, revision);
  return FirmwareVersionMessage.endFirmwareVersionMessage(builder);
}

unpack(): FirmwareVersionMessageT {
  return new FirmwareVersionMessageT(
    this.major(),
    this.minor(),
    this.revision()
  );
}


unpackTo(_o: FirmwareVersionMessageT): void {
  _o.major = this.major();
  _o.minor = this.minor();
  _o.revision = this.revision();
}



unpackFields(...fields: string[]): FirmwareVersionMessageT {
  const t = new FirmwareVersionMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('major')) {
    t.major = this.major();
  }
  if (fieldSet.has('minor')) {
    t.minor = this.minor();
  }
  if (fieldSet.has('revision')) {
    t.revision = this.revision();
  }
  return t;
}
}

export class FirmwareVersionMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public major: number = 0,
  public minor: number = 0,
  public revision: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return FirmwareVersionMessage.createFirmwareVersionMessage(builder,
    this.major,
    this.minor,
    this.revision
  );
}

clone(): FirmwareVersionMessageT {
  const obj = new FirmwareVersionMessageT();
  obj.major = this.major;
  obj.minor = this.minor;
  obj.revision = this.revision;
  return obj;
}

equals(other: FirmwareVersionMessageT): boolean {
  if (this.major !== other.major) return false;
  if (this.minor !== other.minor) return false;
  if (this.revision !== other.revision) return false;
  return true;
}
}

export function verifyFirmwareVersionMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
  } finally {
    verifier.popDepth();
  }
}
